"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateEmailAddress = validateEmailAddress;
exports.validatePassword = validatePassword;
exports.validateToken = validateToken;
function validateEmailAddress(value) {
  var emailReg = /^([a-z0-9_\-.+])+@([a-z0-9_\-.])+\.([a-z])+$/;
  return emailReg.test(value);
}
function validatePassword(value) {
  if (value.trim() === "") {
    return false;
  }
  return true;
}
function validateToken(token) {
  return token && token.length > 0;
}